import { Leaf, AlertTriangle } from 'lucide-react'

function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="relative mt-auto">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-green-300/50 to-transparent"></div>
      
      <div className="bg-gradient-to-br from-green-50/80 via-white/60 to-amber-50/40 backdrop-blur-sm border-t border-green-200/40">
        <div className="max-w-4xl mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-gradient-to-br from-green-400 to-emerald-500 rounded-full flex items-center justify-center shadow-md shadow-green-300/30">
                <Leaf className="w-4 h-4 text-white" />
              </div>
              <span className="text-sm font-medium text-gray-700">
                烟草信息查询系统
              </span>
            </div>
            
            <div className="text-sm text-gray-500">
              © {currentYear} 版权所有
            </div>
          </div>
          
          <div className="mt-4 p-4 bg-gradient-to-r from-amber-50/90 to-orange-50/90 border border-amber-200/50 rounded-2xl">
            <div className="flex items-center justify-center gap-2 mb-2">
              <AlertTriangle className="w-5 h-5 text-amber-500" />
              <span className="font-bold text-amber-700">吸烟有害健康！</span>
            </div>
            <p className="text-center text-sm text-amber-600/80">
              本网站含有烟草内容，未成年人谢绝访问
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer